import React from 'react';

const Terms = () => {
  return (
    <div className="container mt-5 mb-5">
      <h2 className="text-success fw-bold mb-4">Terms and Conditions</h2>

      <p>
        Welcome to <strong>IoVendoSiciliano</strong>, an online marketplace that connects sellers of Sicilian products with customers. By using our platform, you agree to the following terms and conditions:
      </p>

      <h5 className="text-success mt-4 mb-2">1. Platform Responsibility</h5>
      <p>
        IoVendoSiciliano acts solely as an intermediary platform facilitating transactions between buyers and independent sellers. We do not manufacture, store, or ship any products ourselves. All items are sold directly by third-party sellers.
      </p>

      <h5 className="text-success mt-4 mb-2">2. Product Accuracy</h5>
      <p>
        Sellers are solely responsible for the accuracy of product descriptions, prices, availability, images, and other relevant information. IoVendoSiciliano is not responsible for any discrepancies or misleading content provided by sellers.
      </p>

      <h5 className="text-success mt-4 mb-2">3. Payments and Refunds</h5>
      <p>
        Payments are processed securely through our integrated payment systems. In the event of a dispute or request for a refund, <strong>the seller is fully and exclusively responsible</strong> for handling and issuing the refund. IoVendoSiciliano does not intervene in refund or compensation processes.
      </p>

      <p className="fw-bold text-danger">
        IoVendoSiciliano declines all responsibility regarding refund management. Any refund, return, or financial compensation must be agreed directly with the seller.
      </p>

      <h5 className="text-success mt-4 mb-2">4. Shipping and Delivery</h5>
      <p>
        Shipping times, methods, and costs are determined by the individual seller. IoVendoSiciliano is not responsible for delayed, lost, or damaged shipments. Any issues related to delivery must be resolved with the seller.
      </p>

      <h5 className="text-success mt-4 mb-2">5. Seller Obligations</h5>
      <p>
        Sellers must comply with all applicable laws and regulations, including but not limited to tax compliance, product safety, and commercial practices. Sellers are also responsible for providing valid documentation and contact information.
      </p>

      <h5 className="text-success mt-4 mb-2">6. Buyer Conduct</h5>
      <p>
        Buyers agree to provide accurate information and to respect all terms related to payment and delivery. Any attempt at fraud or abuse will result in account suspension or legal consequences.
      </p>

      <h5 className="text-success mt-4 mb-2">7. Liability Disclaimer</h5>
      <p>
        IoVendoSiciliano is not liable for any direct or indirect damage resulting from the use of the platform, including failed deliveries, quality issues, or unsatisfactory services provided by sellers.
      </p>

      <h5 className="text-success mt-4 mb-2">8. Changes to the Terms</h5>
      <p>
        We reserve the right to modify these terms and conditions at any time. Updates will be posted on this page and are effective immediately upon publication.
      </p>

      <p className="mt-4">
        By using our platform, you acknowledge that you have read, understood, and accepted these Terms and Conditions in full.
      </p>
    </div>
  );
};

export default Terms;
